import { render, staticRenderFns } from "./JournalPage.vue?vue&type=template&id=3794999e&"
import script from "./JournalPage.vue?vue&type=script&lang=ts&"
export * from "./JournalPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports